import { Col } from 'antd'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'

import { TYPE } from '@services/report'
import type { ICommonTitle } from './type'

export default function ChartTitle({
  yAxisDateStr,
  sessionName,
  queryVariables,
  yAxisName,
  className
}: ICommonTitle) {
  const { t } = useTranslation()

  return (
    <Col
      span={24}
      className={cx("mt-40 text-largest font-medium text-darkGrey  flex justify-center", className)}>
      {queryVariables?.reportType === TYPE.MONTH
        ? `${new Date().getFullYear()}${t('report:year')}${yAxisDateStr}`
        : yAxisDateStr}
      {sessionName ? `${sessionName} ` : ''}
      {queryVariables?.deviceType
        ? t(`device:select-${queryVariables?.deviceType}`)
        : ''}
      {yAxisName}
    </Col>
  )
}
